import * as Sentry from "@sentry/react";

type FeatureErrorBoundaryProps = {
  children: React.ReactNode;
  feature: string;
  route: string;
};

export default function FeatureErrorBoundary({
  children,
  feature,
  route,
}: FeatureErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag("feature", feature);
        scope.setTag("route", route);
        scope.setContext("feature_route", { feature, route });
      }}
      fallback={({ resetError }) => (
        <div style={{ padding: 24 }}>
          <h2>Something went wrong</h2>
          <p>Please reload this page and try again.</p>
          <button onClick={resetError}>Reload</button>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
